require('./ctxCheckbox.style.scss');

class CtxCheckboxController {
    constructor($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
    }

    $onInit() {

    }
}

CtxCheckboxController.$inject = ['$scope', '$element'];

const ctxCheckboxComponent = {
    restrict: 'E',
    controller: CtxCheckboxController,
    scope: {},
    template: require('./ctxCheckbox.template.html'),
    bindings: {
        name: '@',
        value: '=',
        label: '@?',
        labelPlacement: '@?',
        chkClass: '@?',
        onChange: '&?',
        isDisabled: '<?',
    }
};

module.exports = ctxCheckboxComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxCheckbox/ctxCheckbox.component.js